/* eslint-disable id-length */
export const ADELPHI_SPIRIT_REDUCTIONS_TARGETS = {
  CURRENT_ADELPHI_SPIRIT_REDUCTION: 'currentAdelphiSpiritReduction',
  CREATE_ADELPHI_SPIRIT_REDUCTION: 'createAdelphiSpiritReduction',
  ADELPHI_SPIRIT_REDUCTIONS: 'adelphiSpiritReductions',
  UPDATE_ADELPHI_SPIRIT_REDUCTION_BY_ID: 'updateAdelphiSpiritReductionById',
  ADELPHI_SPIRIT_REDUCTION_BY_ID: 'adelphiSpiritReductionById'
};

export const ADELPHI_SPIRIT_REDUCTIONS_DEFAULT_STATE = {
  [ADELPHI_SPIRIT_REDUCTIONS_TARGETS.CURRENT_ADELPHI_SPIRIT_REDUCTION]: null,
  [ADELPHI_SPIRIT_REDUCTIONS_TARGETS.CREATE_ADELPHI_SPIRIT_REDUCTION]: null,
  [ADELPHI_SPIRIT_REDUCTIONS_TARGETS.ADELPHI_SPIRIT_REDUCTIONS]: [],
  [ADELPHI_SPIRIT_REDUCTIONS_TARGETS.UPDATE_ADELPHI_SPIRIT_REDUCTION_BY_ID]: null,
  [ADELPHI_SPIRIT_REDUCTIONS_TARGETS.ADELPHI_SPIRIT_REDUCTION_BY_ID]: null
};
